import Vue from 'vue';
import zenScroll from 'zenscroll';
import Errors from '../classes/Errors';

Vue.component('contact-form-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {},

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        async onSubmit(event) {
            const Axios = await import(/* webpackChunkName: "axios" */ 'axios')
                .then((module) => module.default)
                .catch(() => {
                    console.log('Handle error!');
                });

            const form = this.$el;
            if (this.submitting || this.formCompleted) {
                return;
            }

            this.submitting = true;

            Axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
            Axios.post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        this.scrollToFirstError();
                        return;
                    }

                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'contact voltooid',
                        contactOption: form.contactOption.value,
                        firstName: form.firstName.value,
                        // lastName: form.lastName.value,
                        // address: form.address.value,
                        // postalCode: form.zipCode.value,
                        // city: form.city.value,
                        phone: form.phoneNumber.value,
                        email: form.email.value,
                        // subject: form.subject.value,
                        message: form.message.value,
                    });

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();
                    // this.scrollToTop();
                })
                .catch((error) => {
                    this.submitting = false;
                    console.error(error);
                });
        },

        scrollToFirstError() {
            const firstError = document.querySelector('.error-message');
            if (firstError) {
                zenScroll.center(firstError);
            }
        },
    },
});
